import _ from 'lodash';
import {
  createReducer,
  createFetchActionForNamespace,
  createFetchReducers,
  createFetchSelectors,
  createFetchReducersWithPagination
} from 'utils/reducers';

const createFetchAction = createFetchActionForNamespace('users/detail');

export const fetchMemberForDashboard = createFetchAction({
  name: 'FETCH_MEMBER_FOR_DASHBOARD',
  initialAction: ({locationRef, memberId}, extraActions = []) => ({
    payload: {locationRef, memberId, extraActions}
  }),
  stateKey: 'member'
});
const memberSelector = createFetchSelectors(fetchMemberForDashboard);
export const selectMember = memberSelector.data;
export const selectMemberLoading = memberSelector.isLoading;

export const fetchUser = createFetchAction({
  name: 'FETCH_USER',
  initialAction: ({userId}, extraActions = []) => ({
    payload: {userId, extraActions}
  }),
  stateKey: 'userDetails',
  defaultStateValue: {}
});
export const selectUser = createFetchSelectors(fetchUser).data;

export const fetchMemberBookingSets = createFetchAction({
  name: 'FETCH_MEMBER_BOOKING_SETS',
  initialAction: ({memberId, locationRef}, extraActions = []) => ({
    payload: {memberId, locationRef, extraActions}
  }),
  stateKey: 'bookingSets',
  defaultStateValue: []
});

export const selectMemberBookingSets = createFetchSelectors(
  fetchMemberBookingSets
).data;

const initialState = {};

const fetchReducers = createReducer(initialState, {
  ...createFetchReducers(fetchMemberForDashboard),
  ...createFetchReducers(fetchUser),
  ...createFetchReducersWithPagination(fetchMemberBookingSets)
});

const reducer = (state = initialState, action) => {
  const newState = fetchReducers(state, action);

  switch (action.type) {
    default:
      return newState;
  }
};

export default reducer;
export {default as userDetailSaga} from './saga';
